//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 15px 25px;
`;
export const SettingsFormWrapper = styled.section`
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: var(--light-1);
    padding: 45px 95px;
    width: 85%;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 20px;
    border-radius: 8px;
`;